import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@prcins/environments';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ContactInfoService {
    constructor(http) {
        this.http = http;
        this.baseUrl = environment.BASE_URL; // Adjust this to your actual API endpoint
    }
    getContactInfoFromServer(userId) {
        return this.http.get(`${this.baseUrl}/account/getContactInfo/${userId}`);
    }
    /**
     * Returns an observable with { shouldShow: boolean, contactInfo: any }
     * Handles all popup logic and provides contact info for pre-population.
     */
    getContactInfo(userId) {
        return new Observable(observer => {
            this.getContactInfoFromServer(userId).subscribe((data) => {
                const contactInfo = data || {};
                const phoneNumber = contactInfo.phoneNumber;
                const email = contactInfo.email;
                //const doNotShowAgain = contactInfo.doNotShowAgain;
                let shouldShow = true;
                if (phoneNumber && email) {
                    shouldShow = false;
                }
                else if ((!phoneNumber || !email)) {
                    shouldShow = true;
                }
                observer.next({ shouldShow, contactInfo });
                observer.complete();
            }, () => {
                observer.next({ shouldShow: true, contactInfo: {} });
                observer.complete();
            });
        });
    }
    updateContactInfo(userId, contactInfo) {
        // contactInfo should contain: email, phoneNumber, mobileIndicator, doNotShowAgain
        return this.http.post(`${this.baseUrl}/account/updateContactInfo/${userId}`, contactInfo);
    }
}
ContactInfoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContactInfoService_Factory() { return new ContactInfoService(i0.ɵɵinject(i1.HttpClient)); }, token: ContactInfoService, providedIn: "root" });
